import { Link as RouterLink } from 'react-router-dom';

import logo from '../assets/logo.png'
// ----------------------------------------------------------------------



export default function Logo() {



  return <RouterLink to="/">  <img src={logo} alt="logo" style={{width:"150px"}}/></RouterLink>;
}
